import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";

import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "./registerServiceWorker";

const firebaseConfig = {
  apiKey: "AIzaSyDNzrMsLTm_N_XCFVq2Y6CHUD0IUXj8Tk8",
  authDomain: "json2model.firebaseapp.com",
  projectId: "json2model",
  messagingSenderId: "167332384469",
  appId: "1:167332384469:web:90aee2075083a1c31e5c5c",
  measurementId: "G-PC1XQHD3GF"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.auth();

Vue.config.productionTip = false;

Vue.prototype.$analytics = firebase.analytics();
Vue.prototype.$auth = firebase.auth();

import hljs from "highlight.js";
import "highlight.js/styles/vs.css";
Vue.use(hljs.vuePlugin);

import Ads from "vue-google-adsense";
Vue.use(require("vue-script2"));
Vue.use(Ads.Adsense);

new Vue({
  vuetify,
  render: h => h(App)
}).$mount("#app");
